module.exports = __webpack_public_path__ + "static/img/331_phase_function_Paper_PointsHejduk_Prediction.bfb7961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/331_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 39mx
// module chunks = 0